import React from 'react';
import { MarkAsBounced } from '@saleshandy/icons';

const ProspectActivityEmailBouncedColored = () => (
  <MarkAsBounced width={16} height={16} className="red-txt-13" />
);

export default ProspectActivityEmailBouncedColored;
